import React from 'react';

interface ButtonProps {
  modifiers?: string;
  className?: string;
  ariaLabel?: string;
  children?: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const Button = ({ modifiers, className, ariaLabel, children, onClick }: ButtonProps) => (
  <button
    type="button"
    data-am-button={modifiers}
    onClick={onClick}
    className={className}
    title={ariaLabel}
    aria-label={ariaLabel}
  >
    {children}
  </button>
);

export default Button;
